/** @format */

import { Provider } from "react-redux";
import { BrowserRouter, useNavigate } from "react-router-dom";
import "./App.css";
import Router from "./routes";
import store from "./store/store";
import ThemeProvider from "./theme";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useEffect, useState } from "react";
import axios from "axios";
import SuperAdminRoutes from "./superAdminRoutes";
import Loader from "./componants/Loader";
import LogInRoutes from "./logInRoutes";
import PostpaidAdminRoutes from "./postpaidAdminRoutes";
import { logoutChannel } from "./auth/broadcastSetup";
import { ChakraProvider } from "@chakra-ui/react";
import { base_url } from "./utils";

function App() {
  const [state, setstate] = useState("");

  useEffect(() => {
    if (sessionStorage.getItem("token") === "success") {
      axios.get(`${base_url}/EsignServices/getUserDetails`).then((response) => {
        setstate(response.data);
      });
    }
  }, []);

  logoutChannel.onmessage = (event) => {
    if (event.data === "logout") {
      // Perform the logout operation in other components
      // ...
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("email");
      window.location.replace("/login");
    }
  };

  return (
    <>
      <ChakraProvider>
        <GoogleOAuthProvider clientId='24660824558-ipphkbm597n20isvqq6doc0b2kebku54.apps.googleusercontent.com'>
          <BrowserRouter>
            <ThemeProvider>
              <Provider store={store}>
                {state.admin_type === "user" ? (
                  state.account_type === "Prepaid" ? (
                    <Router />
                  ) : (
                    <PostpaidAdminRoutes />
                  )
                ) : state.admin_type === "superAdmin" ? (
                  <SuperAdminRoutes />
                ) : sessionStorage.getItem("token") !== "success" ? (
                  <LogInRoutes />
                ) : (
                  <Loader />
                )}
              </Provider>
            </ThemeProvider>
          </BrowserRouter>
        </GoogleOAuthProvider>
      </ChakraProvider>
    </>
  );
}

export default App;
